import { ComponentType } from 'react';
import {
  Subtitle,
  Title,
  TwoColumnSubtitle,
  TwoColumnTitle,
  TwoColumnWrapper,
  Wrapper,
} from './EmptyState.styles';
import { EMPTY_STATE_VARIANTS } from './EmptyState.types';

export type Props = {
  Illustration: ComponentType<React.PropsWithChildren<unknown>>;
  title: string;
  subtitle: React.ReactNode;
  variant?: EMPTY_STATE_VARIANTS;
};

export const EmptyState = ({
  Illustration,
  title,
  subtitle,
  variant = EMPTY_STATE_VARIANTS.DEFAULT,
  ...props
}: Props) => (
  <>
    {variant !== EMPTY_STATE_VARIANTS.ILLUSTRATION_TWO_COL ? (
      <Wrapper variant={variant} {...props}>
        <Illustration />
        <Title data-test="empty-state-title">{title}</Title>
        <Subtitle data-test="empty-state-sub-title">{subtitle}</Subtitle>
      </Wrapper>
    ) : (
      <TwoColumnWrapper {...props}>
        <Illustration />
        <div>
          <TwoColumnTitle data-test="empty-state-title">{title}</TwoColumnTitle>
          <TwoColumnSubtitle data-test="empty-state-sub-title">{subtitle}</TwoColumnSubtitle>
        </div>
      </TwoColumnWrapper>
    )}
  </>
);
